import { BrowserRouter as Router } from "react-router-dom";
import { useState, useEffect } from "react";
import NewRouter from "./routes/sections";
import user from "src/components/UI/Shared/user";
import "src/App.scss";
import "src/assets/scss/BaseMap.scss";

function App() {
  useEffect(() => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    if (data) {
      const user_data = JSON.parse(data);
      const user_ip_data = user_data?.ip_data;

      if (!user_ip_data) {
        user.getUserIp(user_data, current_user);
      } else {
        user.checkUserIp(user_data, current_user);
      }
    } else {
      user.getUserIp(current_user);
    }
  }, []);
  return (
    <Router basename="/Geo">
      <NewRouter />
    </Router>
  );
}

export default App;
